export function openIntercomMessenger() {
  const { Intercom } = window;
  Intercom && Intercom('show');
}